import React, { memo } from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

const TasksGlanceCell = ({ completed = 0, total = 0, docsPending = 0 }) => {
  const doneLabel = `${completed}/${total} done`;
  const label =
    docsPending > 0
      ? `${doneLabel} · ${docsPending} ${docsPending === 1 ? 'doc' : 'docs'} pending`
      : doneLabel;

  return (
    <Typography noWrap color="text.secondary" title={label} variant="regular14">
      {label}
    </Typography>
  );
};

TasksGlanceCell.propTypes = {
  completed: PropTypes.number,
  total: PropTypes.number,
  docsPending: PropTypes.number,
};

export default memo(TasksGlanceCell);
